import uid from './uid'
import hint from './hint'
import isEmpty from 'lodash.isempty'

export default {
    mixins: [uid, hint],

    props: {
        value: null,
        name: null,
        required: Boolean,
        requiredWarn: Boolean,
        placeholder: null,
        disabled: Boolean,
        readonly: Boolean,
        inline: Boolean,
        xs: Boolean,
        sm: Boolean,
        lg: Boolean,
        helper: null,
        autocomplete: null,
        min: {
            type: Number,
            default: undefined,
        },
        max: {
            type: Number,
            default: undefined,
        },
    },

    computed: {
        hasDefaultSlot() {
            return Boolean(this.$slots.default)
        },
        maxLength() {
            return `${this.internalValue?.length || 0}/${this.max || 0}`
        },
        minLength() {
            return `${this.internalValue?.length || 0}/${this.min || 0}`
        },
        minMaxLength() {
            return `${this.internalValue?.length || 0}/${this.min || 0}-${this.max || 0}`
        },
        warning() {
            return this.required && this.requiredWarn && !this.internalValue && !this.focus
        },
        lengthValidation() {
            return (this.max !== undefined || this.min !== undefined) && !this.isNumber
        },
        isNumber() {
            return this.type === 'number'
        },
        isText() {
            return this.type === 'text'
        },
    },

    methods: {
        onInput(evt) {
            if (!this.disabled && !this.readonly) {
                let value = evt.target.value
                if (this.isNumber) {
                    if (value === '') {
                        value = 0
                        evt.target.value = value
                    } else if (value.length > 1 && value.charAt(0) === '0') {
                        value = value.substring(1)
                    }
                    if (value > this.max) {
                        value = this.max
                        evt.target.value = this.max
                    }
                    if (value < this.min) {
                        value = this.min
                        evt.target.value = this.min
                    }
                }
                if (this.isText && !value.length) {
                    value = undefined
                }
                this.internalValue = value
                this.$emit('input', value, this)
            }
        },

        focusInput() {
            if (!this.disabled && this.$refs.inputEl) {
                this.$refs.inputEl.focus({ preventScroll: true, focisVisible: true })
            }
        },

        onFocus(evt) {
            if (!this.disabled) {
                this.focus = true
                this.$emit('focus', evt)
            }
        },

        onBlur(evt) {
            if (!this.disabled) {
                this.focus = false
                this.$emit('blur', evt)
            }
        },

        onChange(evt) {
            if (!this.disabled) this.$emit('change', evt.target.value)
        },

        onEnter(evt) {
            if (!this.disabled && !evt.shiftKey) {
                evt.preventDefault()
                evt.stopPropagation()
                this.$emit('enter', evt.target.value)
            }
        },
    },

    watch: {
        value: {
            immediate: true,
            handler(value, oldValue) {
                if (value !== this.internalValue) {
                    if (isEmpty(oldValue) && !isEmpty(value) && !this.disabled) {
                        this.$emit('input', value, this)
                    }
                    this.internalValue = value
                }
            },
        },
        hintText: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.$nextTick(() => {
                        this.needTooltip =
                            this.$refs.feedback?.clientWidth < this.$refs.feedback?.scrollWidth
                    })
                } else if (this.needTooltip) {
                    this.needTooltip = false
                }
            },
        },
    },

    data() {
        return {
            internalValue: this.value,
            needTooltip: false,
            focus: false,
        }
    },
}
